import classNames from 'clsx';
import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import { mergeRefs } from 'react-merge-refs';
import { useContextSelector } from 'use-context-selector';
import { MarkdownOpenExternalLinkCtx } from '../ctx/OpenExternalLinkCtx';
import mediumZoomStyles from '../markdown-img-zoom.module.less';
import { handleImageSrcAddParams } from '../plugins/plugin-image-src-add-params';
import { handleImageUrl } from '../plugins/remark-image-replace-host';

const TagImage = React.forwardRef<
  HTMLImageElement,
  React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
>(function (imgProps, ref) {
  const enableImageReplaceHost = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => !!data.imageReplaceHostOptions,
  );
  const ImageSrcAddParamsHandler = useContextSelector(MarkdownOpenExternalLinkCtx, (data) => {
    const enableImageSrcAddParams = !!data.imageSrcAddParams;
    return enableImageSrcAddParams ? handleImageSrcAddParams(data.imageSrcAddParams!) : undefined;
  });
  const searchHostname = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => data.imageReplaceHostOptions?.searchHostname,
  );
  const replaceHostname = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => data.imageReplaceHostOptions?.replaceHostname,
  );
  const customDomainRequestPath = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => data.imageReplaceHostOptions?.customDomainRequestPath,
  );

  const isEnterpriseEdition = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => data.imageReplaceHostOptions?.isEnterpriseEdition,
  );

  const handler = useMemo(
    () =>
      enableImageReplaceHost
        ? handleImageUrl(
            searchHostname!,
            replaceHostname!,
            customDomainRequestPath!,
            isEnterpriseEdition,
          )
        : undefined,
    [
      enableImageReplaceHost,
      searchHostname,
      replaceHostname,
      customDomainRequestPath,
      isEnterpriseEdition,
    ],
  );

  // Zoom: medium-zoom
  // enableImageReplaceHost
  let src = imgProps.src;
  src = src ? ImageSrcAddParamsHandler?.(src) ?? src : src;
  src = src ? handler?.(src) ?? src : src;
  // enableImageSrcAddParams
  const imgRef = useRef<HTMLImageElement>(null);
  const [mediumZoomIns, setMediumZoomIns] = useState<typeof import('medium-zoom')>();
  useLayoutEffect(() => {
    import('medium-zoom').then((mediumZoom) => {
      setMediumZoomIns(mediumZoom);
    });
  }, []);

  return (
    <img
      ref={mergeRefs([ref, imgRef])}
      {...imgProps}
      {...{
        src,
        loading: 'lazy',
      }}
      className={classNames(imgProps.className, mediumZoomIns ? mediumZoomStyles.mediumZoom : null)}
      onClick={() => {
        const img = imgRef.current;
        if (img && mediumZoomIns) {
          // if (!bindZoomEvt.current) {
          if (!img.closest('a[data-href]')) {
            const zoom = mediumZoomIns.default(img);
            zoom.open();
            zoom.detach(img);
          }
          // bindZoomEvt.current = true;
          // }
        }
      }}
    />
  );
});

export { TagImage };
